import axios from 'axios';
import { combineReducers } from 'redux';
import createConfiguredStore from '@wix/restaurants-redux/dist/store/ConfigureReduxStore';
import PhoneUtils from '@wix/wixrest-utils/dist/PhoneUtils';
import { createRestClient } from 'wix-restaurants-js-sdk/dist/clients/index';
import reducers from './reducers';
import sagas from '../sideEffects';
import InstanceClient from '../../apiClients/instanceClient';
import LocaleClient from '../../apiClients/localeClient';
import { initHistory } from './actions/HistoryActions';
import { setFirstTime, setInstance, setMsid, setUser } from './actions/SessionActions';
import { LOCAL_STORAGE_FIRST_TIME_KEY } from './reducers/SessionReducer';

const sagaParams = {
  axios,
  restClient: createRestClient({ timeout: 0 }),
  mappingClient: createRestClient({
    timeout: 0,
    baseUrl: 'https://mapping.wixrestaurants.com/v1',
  }),
  authentication: createRestClient({
    timeout: 0,
    baseUrl: 'https://auth.wixrestaurants.com/v2',
  }),
  wixApiClient: createRestClient({
    timeout: 0,
    baseUrl: 'https://www.wix.com',
  }),
  instanceClient: new InstanceClient(),
  localeClient: new LocaleClient(),
  PhoneUtils,
};

const createStore = (initialState, env = {}, extraParams = {}) => {
  sagaParams.env = env;
  const isFirstTime = !extraParams.localStorage.getItem(LOCAL_STORAGE_FIRST_TIME_KEY);

  const confStore = {
    reducers,
    sagas,
    sagaParams: {
      ...sagaParams,
      ...extraParams,
    },
    middlewares: [],
    useLogger: false,
  };

  if (initialState) {
    confStore.initialState = initialState;
  }

  const store = createConfiguredStore(confStore);

  if (env.userProfile) {
    store.dispatch(setUser({ user: env.userProfile }));
  }
  if (env.msid) {
    store.dispatch(setMsid({ msid: env.msid }));
  }

  if (env.instance || env.fallbackInstance) {
    store.dispatch(setInstance({ signedInstance: env.instance, fallbackSignedInstance: env.fallbackInstance }));
  }

  if (isFirstTime) {
    store.dispatch(setFirstTime({ value: true }));
  }
  store.dispatch(initHistory());

  if (module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(combineReducers(require('./reducers').default)));
  }

  if (env.debug && typeof window !== 'undefined') {
    window.printState = () => {
      console.log(store.getState());
    };
  }

  return store;
};

export function storeFactory() {
  let store = null;
  return function createStoreWrapper(initialState, env, extraParams) {
    if (!store) {
      store = createStore(initialState, env, extraParams);
    }
    return store;
  };
}

export default createStore;
